import { useLayoutEffect } from "react";

export function MarkMounted() {
  useLayoutEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.dataset.mounted = "true";
      root.dataset.release = "2026-09-23-blank-page-fix";
    }
  }, []);

  return null;
}
